import React, { useContext } from 'react'
import { css } from '@emotion/react'
import { rgba } from 'polished'
import { colors, fonts, timings, effectsAndImpacts } from 'shared-ui'
import BodyPart from '../../context/BodyPart'
import SurfaceLayer from '../../context/SurfaceLayer'

const { getScoredImpactsFromTests, getModelProps } = effectsAndImpacts

const style = {
    effectsListItem: (isHighlighted) => css`
        display: flex;
        gap: 1em;
        align-items: center;
        font-family: ${fonts.base};
        line-height: 1.5;
        font-size: 0.875em;
        padding: 0.6em 0.75em;
        background-clip: padding-box;
        border: 0.2em solid transparent;
        border-radius: 0.125em;
        background-color:  ${isHighlighted ? 'rgba(65, 132, 130, 1)' : rgba(colors.subtle, 0.2)};
        transform: translateX(${isHighlighted ? '-1em' : '0em'});
        transition: transform, background-color, ${timings.responsive} ease;
    `,
    assessmentOrb: (color) => css`
        margin-left: 1em;
        height: 1em;
        width: 1em;
        min-height: 1em;
        min-width: 1em;
        border-radius: 0.5em;
        background-color: ${color};
        box-shadow: 0 0 0.75em ${color};
    `
}

export default function EffectsList({ tests = [], type, filter, ...props }) {

    const [partFocus, setPartFocus] = useContext(type === 'pitch' ? SurfaceLayer : BodyPart)
    const { scoredImpacts } = getScoredImpactsFromTests(tests, type, Infinity, filter)
    const { effectName, partName } = getModelProps(type)

    return (
        <div {...props}>
            {(scoredImpacts && scoredImpacts.length > 0) &&
                scoredImpacts.map((effect) => {

                    const id = effect.id
                    const label = effect[effectName]?.label
                    const part = effect[effectName]?.[partName]
                    const color = effect.severityColor

                    return (
                        <div
                            key={id}
                            css={style.effectsListItem(partFocus === part)}
                            onClick={(e) => {
                                e.preventDefault()
                                setPartFocus(current => current === part ? '' : part)
                            }}
                            onMouseEnter={() => {
                                setPartFocus(part)
                            }}
                            onMouseLeave={() => {
                                setPartFocus('')
                            }}
                        >
                            <div css={style.assessmentOrb(color)} />
                            <span>
                                {label}
                            </span>
                        </div>
                    )
                })
            }
        </div>
    )
}